module.exports = __webpack_public_path__ + "img/bg-four.af6f7b22.jpg";